import { queryOptions } from '@tanstack/react-query'
import { Pagination } from '@thinknimble/tn-models'
import { asyncJobApi } from './api'

export const asyncJobQueries = {
  all: () => ['async-jobs'],
  retrieve: (id: string) => {
    return queryOptions({
      queryKey: [...asyncJobQueries.all(), id],
      queryFn: () => asyncJobApi.retrieve(id),
      enabled: Boolean(id),
    })
  },
  listActive: () => {
    return queryOptions({
      queryKey: [...asyncJobQueries.all(), 'active'],
      queryFn: async () => {
        const res = await asyncJobApi.list({
          filters: { status: 'active' },
        })
        return res.results
      },
    })
  },
  listRecent: ({
    pagination,
    paginationCallback,
  }: {
    pagination?: Pagination
    paginationCallback?: (pagination: Pagination) => void
  } = {}) => {
    return queryOptions({
      queryKey: [...asyncJobQueries.all(), 'recent', { pagination }],
      queryFn: async () => {
        const res = await asyncJobApi.list({
          filters: { status: 'recent' },
          pagination,
        })
        if (paginationCallback) {
          const serverPagination = new Pagination({ ...res, totalCount: res.count })
          paginationCallback(serverPagination)
        }
        return res
      },
    })
  },
}
